import { DeviceAllocation, Unit } from 'src/store/sageAdminApi';
import { DeviceQaSession } from 'src/store/sageDeviceAuditApi';

export type ResolvedDeviceQaSession = DeviceQaSession & {
    deviceAllocation: DeviceAllocation;
};

export const DeviceBatteryStatuses = {
    Unknown: 'UNKNOWN',
    LowBattery: 'LOW_BATTERY',
    Normal: 'NORMAL',
} as const;
export type DeviceBatteryStatusType =
    (typeof DeviceBatteryStatuses)[keyof typeof DeviceBatteryStatuses];

export type UnitAuditDetails = {
    unit?: Unit;
    deviceQaSessions?: ResolvedDeviceQaSession[];
};
